import { tv } from 'tailwind-variants';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

const RING_MASK = 'radial-gradient(farthest-side, transparent calc(100% - 4px), black calc(100% - 4px))';

export enum SpinnerColor {
  GRAY = 'gray',
  GREEN = 'green',
}

const styleSpinner = tv({
  base: 'h-5 w-5 animate-spin rounded-full',
  variants: {
    color: {
      [SpinnerColor.GRAY]: '[background:conic-gradient(from_0deg,theme(colors.gray.200),theme(colors.gray.400))]',
      [SpinnerColor.GREEN]: '[background:conic-gradient(from_0deg,theme(colors.green.100),theme(colors.green.400))]',
    },
  },
  defaultVariants: {
    color: SpinnerColor.GRAY,
  },
});

interface SpinnerProps {
  color?: SpinnerColor;
}

export function Spinner({ color = SpinnerColor.GRAY }: SpinnerProps) {
  return (
    <div
      data-testid={DataTestIdEnum.SPINNER}
      className={styleSpinner({ color })}
      style={{ mask: RING_MASK, WebkitMask: RING_MASK }}
    />
  );
}
